/* Native share sheet for the product share drawer.

   Filippo asked for an Instagram button (28 Aug 2026). Instagram publishes no web share
   intent, so a page cannot hand it a link. What CAN reach Instagram is the device's own
   share sheet, which lists Instagram Stories next to WhatsApp, Telegram and Messages —
   so that is what this button opens.

   The button ships `hidden` from the Liquid and is revealed only where navigator.share
   actually exists (phones, and Safari on macOS). Desktop Chrome and Firefox have no share
   sheet, so there the button stays hidden and the drawer just shows the five link buttons.

   Two constraints shape this file:

   1. product-block-share.liquid can render more than once per page (main-page.liquid
      renders it twice, once per layout), so the <script> tag can appear twice. Everything
      is guarded by a single global flag. A custom element would have thrown on the second
      customElements.define() call.
   2. Buttons can arrive after load — the share drawer is inside the product form, which
      section rendering replaces on a variant change. So the click handler is delegated on
      document and the reveal re-runs on DOMContentLoaded and on shopify:section:load. */

(function () {
  if (window.__rilensNativeShare) return;
  if (!navigator.share) return;
  window.__rilensNativeShare = true;

  function reveal() {
    document.querySelectorAll('.rilens-native-share[hidden]').forEach(function (item) {
      item.removeAttribute('hidden');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.rilens-native-share button');
    if (!button) return;

    event.preventDefault();

    /* Fall back to the live location rather than the printed URL: the printed one is right,
       but if this ever renders on a page whose canonical differs, the address bar wins. */
    navigator
      .share({
        url: button.dataset.shareUrl || window.location.href,
        title: button.dataset.shareTitle || document.title,
      })
      /* AbortError just means the shopper closed the sheet. Nothing to report. */
      .catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  document.addEventListener('shopify:section:load', reveal);
})();
